import * as React from "react";

import { UnregisteredPane } from "../UnregisteredPane";
import { RegisteredPane } from "../RegisteredPane";
import { SessionExpiredDialog } from "lib/components/SessionExpiredDialog";
import { Notification } from "lib/components/Notification";
import style from "./style.module.css";
import { HorizontalSplitPane } from "lib/components/SplitPane";

export function App() {
  return (
    <div className={style.root}>
      <HorizontalSplitPane defaultRatio={0.5}>
        <div
          style={{
            borderRight: "1px solid #ccc",
            height: "100%",
            maxHeight: "100%",
            overflow: "auto",
          }}
        >
          <UnregisteredPane />
        </div>
        <div style={{ height: "100%", maxHeight: "100%", overflow: "auto" }}>
          <RegisteredPane />
        </div>
      </HorizontalSplitPane>
      <SessionExpiredDialog />
      <Notification />
    </div>
  );
}
